import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './core/auth.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}
  canActivate(): Observable<boolean> {
    const token = localStorage.getItem('access_token');
      if (!token) {
      console.log("linea 15 auth guard")
      window.location.href = environment.portalUrl + 'auth/iniciar-sesion';
      return of(false);
    }
    return this.authService.authenticate().pipe(
      map(() => true),
      catchError(() => {
        console.log("linea 22 auth guard")
        window.location.href = environment.portalUrl + 'auth/iniciar-sesion';
        return of(false);
      })
    );
  }
}
